import ProductListing from "../components/ProductListing";
import Slider from "../components/Slider";

export default function Home() {
  return (
    <>
      <Slider />
      <ProductListing />
    </>
  );
}
